/**
 * @nubeteck/formeck (0.19.5)
 * Copyright (c) Nubeteck, SRL.
 */
import { j as l } from "../../../chunks/jsx-runtime.BwWtxLpl.js";
import { omit as f } from "radash";
import { d as h } from "../../../chunks/index.esm.eyITaPoj.js";
import { Checkbox as x } from "@nubeteck/components";
import b from "../../form-item/form-item.js";
const p = ({
  name: u,
  help: d,
  label: m,
  rules: i,
  tooltip: t,
  onChange: a,
  defaultValue: c,
  disabledInput: n,
  renderFormItem: s = !0,
  ...e
}) => {
  const { field: r } = h({
    name: u,
    rules: i,
    defaultValue: c,
    disabled: e.disabled
  });
  return /* @__PURE__ */ l.jsx(
    b,
    {
      name: u,
      help: d,
      label: m,
      tooltip: t,
      valuePropName: "checked",
      noStyle: !s,
      required: !!i?.required,
      children: /* @__PURE__ */ l.jsx(
        x,
        {
          ...f(r, ["value"]),
          checked: r.value,
          disabled: n ?? e.disabled,
          onChange: (o) => {
            r.onChange(o.target.checked ?? o.target.value), a && a(o);
          },
          ...e
        }
      )
    }
  );
};
p.Group = function({
  name: d,
  help: m,
  label: i,
  rules: t,
  tooltip: a,
  onChange: c,
  defaultValue: n,
  renderFormItem: s = !0,
  ...e
}) {
  const { field: r } = h({
    name: d,
    rules: t,
    defaultValue: n,
    disabled: e.disabled
  });
  return /* @__PURE__ */ l.jsx(
    b,
    {
      help: m,
      name: d,
      label: i,
      tooltip: a,
      valuePropName: "checked",
      noStyle: !s,
      required: !!t?.required,
      children: /* @__PURE__ */ l.jsx(
        x.Group,
        {
          ...r,
          onChange: (o) => {
            r.onChange(o), c && c(o);
          },
          ...e
        }
      )
    }
  );
};
export {
  p as default
};
